import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

class BannerService {
  getAuthToken() {
    const token = localStorage.getItem('adminToken');
    return token ? `Bearer ${token}` : '';
  }

  // Get all banners
  async getAll(params = {}) {
    try {
      const response = await axios.get(`${API_URL}/admin/banners`, {
        params,
        headers: {
          'Authorization': this.getAuthToken()
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch banners' };
    }
  }

  // Get single banner
  async getById(id) {
    try {
      const response = await axios.get(`${API_URL}/admin/banners/${id}`, {
        headers: {
          'Authorization': this.getAuthToken()
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch banner' };
    }
  }

  // Create banner
  async create(formData) {
    try {
      const response = await axios.post(`${API_URL}/admin/banners`, formData, {
        headers: {
          'Authorization': this.getAuthToken(),
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to create banner' };
    }
  }

  // Update banner
  async update(id, formData) {
    try {
      const response = await axios.put(`${API_URL}/admin/banners/${id}`, formData, {
        headers: {
          'Authorization': this.getAuthToken(),
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to update banner' };
    }
  }

  // Delete banner
  async delete(id) {
    try {
      const response = await axios.delete(`${API_URL}/admin/banners/${id}`, {
        headers: {
          'Authorization': this.getAuthToken()
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to delete banner' };
    }
  }
}

export default new BannerService();
